import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { fromJS, Map, is } from 'immutable';
import { InteractionType as InteractionTypeRecord } from '@instructure/quiz-interactions';
import t from '@instructure/quiz-i18n/format-message';
import { rule } from 'instructure-validations';
import { TEMPORARY_ITEM_ID, BUILD_CHAR_LIMIT, RICH_FILL_BLANK_SLUG } from '@instructure/quiz-common';
import ReduxRecord from './reduxRecord';
import { getInteractionType as _getInteractionType } from '../selectors/interactionTypes';
export var Item = /*#__PURE__*/function (_ReduxRecord) {
  function Item() {
    _classCallCheck(this, Item);
    return _callSuper(this, Item, arguments);
  }
  _inherits(Item, _ReduxRecord);
  return _createClass(Item, [{
    key: "isStimulus",
    get: function get() {
      return false;
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return this.id !== '0';
    }
  }, {
    key: "hasResponse",
    value: function hasResponse(userResponse) {
      if (!userResponse || userResponse.value === null || userResponse.value === void 0) return false;
      return this.getInteractionType().hasResponse(userResponse.value, this.interactionData.toJS());
    }
  }, {
    key: "getChoice",
    value: function getChoice(choiceId) {
      return this.getIn(['interactionData', 'choices'], fromJS([])).find(function (choice) {
        return choice.get('id') === choiceId;
      });
    }
  }, {
    key: "getInteractionType",
    value: function getInteractionType() {
      // if the interaction type wasn't normalized (sample items), we need to get the id from the object
      var interactionTypeId = typeof this.interactionType === 'object' ? this.interactionType.id : this.interactionType;
      return _getInteractionType(this.getState(), interactionTypeId) || new InteractionTypeRecord();
    }
  }, {
    key: "getItemBody",
    value: function getItemBody() {
      if (this.getInteractionType().slug === RICH_FILL_BLANK_SLUG && this.itemBody) {
        return this.itemBody.split(/(?=<span id="blank_)/g).join('_____');
      }
      return this.itemBody;
    }
  }, {
    key: "hasModifications",
    value: function hasModifications() {
      return !is(this.getWorkingInstance(), this);
    }
  }, {
    key: "hasFeedback",
    value: function hasFeedback() {
      return this.getIn(['feedback', 'correct']) || this.getIn(['feedback', 'incorrect']) || this.getIn(['feedback', 'neutral']);
    }
  }, {
    key: "getScoringAlgorithm",
    value: function getScoringAlgorithm() {
      return this.scoringAlgorithm || this.getInteractionType().scoringAlgorithmDefault;
    }
  }, {
    key: "getWorkingInstance",
    value: function getWorkingInstance(overrides) {
      var mods = this.getState().getIn(['modifications', 'items', this.id]);
      var data = this.merge(overrides, mods);
      // needed so we can maintain state... this is sad
      return Item.create(data, this.getState());
    }
  }, {
    key: "isImmutable",
    value: function isImmutable() {
      return this.status === 'immutable';
    }
  }, {
    key: "isTemporary",
    value: function isTemporary() {
      return this.id === TEMPORARY_ITEM_ID;
    }

    // PRIVATE METHODS
  }, {
    key: "__defaultItem",
    value: function __defaultItem() {
      return this.id === '0';
    }
  }], [{
    key: "validations",
    value: function validations() {
      return {
        onSelf: [rule('maxContent', {
          limit: BUILD_CHAR_LIMIT
        })]
      };
    }
  }]);
}(ReduxRecord({
  id: '0',
  title: t('Title'),
  label: t('label'),
  itemBody: t('Question stem'),
  interactionTypeId: '0',
  interactionType: '0',
  interactionData: Map(),
  properties: Map(),
  contextId: null,
  toolName: null,
  parentItemId: null,
  parentItemRelationship: null,
  createdAt: null,
  updatedAt: null,
  scoringAlgorithm: null,
  scoringData: Map(),
  scoringDataSchema: Map(),
  status: 'mutable',
  outcomeDeclaration: null,
  outcomeAlignmentSetGuid: null,
  feedback: Map(),
  answerFeedback: Map(),
  stimulusId: null,
  calculatorType: 'none',
  metadata: Map()
}));
export default Item;